import { IonItem } from "@ionic/react";

function AppFormItem({
  error,
  focused,
  children,
  ...props
}: {
  error: boolean;
  focused: boolean;
  children: React.ReactNode;
  [x: string]: any;
}) {
  return (
    <IonItem
      className={`transition-colors item-input ${
        !!error
          ? "border-red-400 prefers-contrast:border-red-500 dark:prefers-contrast:border-red-300 border"
          : focused
          ? ``
          : `border-transparent`
      }  ${props.className ? props.className : ``}`}
      {...props}
    >
      {children}
    </IonItem>
  );
}

export default AppFormItem;
